<template>
  <div class="page-wraper">
    <div class="page-content d-flex align-items-stretch flex-column h-100">

      <!-- Banner -->
      <div class="banner-wrapper">
        <div class="layer"></div>
        <div class="container inner-wrapper">
          <h1 class="dz-title ">{{ $t('kobo') }}</h1>
          <div class="account-header">
            <h2 class="title ">{{ $t('welcome') }}</h2>
            <h6 class="">{{$t('need_pseudo')}}</h6>
          </div>
        </div>
      </div>
      <!-- Banner End -->
      <div class="d-flex align-items-stretch flex-column mt-auto bg-white shadow" style="border-radius: 20px 20px 0 0 ;height: calc(100% / 2 + 50px);">
        <div class="my-auto px-3">
          <form>
            <div class="input-group input-mini mb-5">
              <span class="input-group-text"><i class="fa fa-user"></i></span>
              <input v-model="formData.pseudo" type="text" class="form-control" placeholder="Pseudo">
            </div>
            <div class="input-group">
              <button @click.prevent="login" class="btn mt-2 btn-primary w-100 btn-rounded" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ $t('continue') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {reactive, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { toast } from 'vue3-toastify';

const store = useStore();
const router = useRouter();
const loading = ref(false)
const formData = reactive({pseudo: ''})

function login() {
  loading.value = true
  store.dispatch('auth/login', formData).then((response) => {
    toast.success("Bienvenue à K'skrout....")
    store.dispatch('restaurant/loadRestaurant').then((response) => {
      router.push({name:'home-page'})
    })
  }).finally(() => {
    loading.value = false
  })
}
</script>

<style scoped>
  .account-header {
    padding-top: 50px;
  }
  form{
    padding-top: 20px;
  }
  .banner-wrapper{
    height: calc(100%/2);
    background-image: url('../../assets/back.png');
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #2da333;
    position: relative;
    z-index: -1;
  }
  .btn-primary:hover{
    background-color: var(--primary);
  }
  .account-area{
    height: calc(100% / 2);
  }
  .banner-wrapper:before{
    width: 0;
    height: 0;
  }
  .banner-wrapper:after{
    width: 0;
    height: 0;
  }
  .layer{
    background-color: #2da333;
    opacity: 0.5;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -2;
  }
  .inner-wrapper{
    z-index: 1;
  }
  .saprate{
    padding: 0;
  }
</style>